/**
 * @author Mihail Sablin <mihail@webprogrammist.com>
 * @copyright Copyright (c) 2023, Mihail Sablin
 * @licence http://www.opensource.org/licenses/mit-license.php MIT licence
 */
;
"use strict";

/**
 * Компонент следит за изменением размера окна браузера и вызывает callback'и
 * при изменении размера окна согласно breakpoint'ам Twitter Bootstrap 5
 *  xs: 0,
 *  sm: 576px,
 *  md: 768px,
 *  lg: 992px,
 *  xl: 1200px,
 *  xxl: 1400px
 */

(function($, window, undefined) {
	"use strict";
	let plugin = $.bootstrapResizeNotifier = {};
	plugin.xs = 'xs';
	plugin.sm = 'sm';
	plugin.md = 'md';
	plugin.lg = 'lg';
	plugin.xl = 'xl';
	plugin.xxl = 'xxl';

	let listeners = [];
	const breakpoints = {
		xs: {min: -1, max: 576, i: plugin.xs},
		sm: {min: 576, max: 768, i: plugin.sm},
		md: {min: 768, max: 992, i: plugin.md},
		lg: {min: 992, max: 1200, i: plugin.lg},
		xl: {min: 1200, max: 1400, i: plugin.xl},
		xxl: {min: 1400, max: 999999, i: plugin.xxl}
	};
	let breakpoint = null;

	let getBreakpoint = function() {
		return breakpoint;
	};
	let getBreakpointName = function() {
		return breakpoint.i;
	};
	/**
	 *
	 * @param {Number} width
	 * @return {String}
	 */
	let calculateBreakpoint = function(width) {
		return Object.values(breakpoints).filter(function(v) {
			return v.min <= width && width < v.max;
		})[0];
	};

	let init = function() {
		window.addEventListener('resize', (evt) => {
			let bp = calculateBreakpoint(document.body.clientWidth);
			if(bp !== breakpoint) {
				breakpoint = bp;
				Object.values(listeners).forEach(function(v, i) {
					v(breakpoint);
				});
			}
		}, true);
		breakpoint = calculateBreakpoint(document.body.clientWidth);
	};
	/**
	 *
	 * @param {Function} callback
	 * @returns {*}
	 */
	plugin.subscribe = function(callback) {
		if($.isFunction(callback)) {
			listeners.push(callback);
			return true;
		} else {
			return $.error('Callback should be instance of [Function]');
		}
	};
	/**
	 *
	 * @param {Function} callback
	 */
	plugin.unsubscribe = function(callback) {
		listeners = listeners.filter(function(v) {
			return v !== callback;
		});
	};
	// let's go!
	$(function() {
		//init();
	});
})(jQuery, window);
